export default __webpack_public_path__ + "static/media/hero-bg.ca548f8a.png";